import $ from 'jquery'
require('jquery.inputmask/dist/jquery.inputmask.bundle.js')

$(function () {
  function init ($el) {
    $el.inputmask({
      clearIncomplete: true,
    })
  }

  init($(':input'))

  $(document).on('focus mouseenter', ':input', function () {
    if (!this.inputmask) {
      init($(this))
    }
  })
})



// WEBPACK FOOTER //
// ./resources/assets/js/inputmask.js